// SAB-466: consent-gated warm-load for the Locance geo scripts.
//
// Sibling of AnalyticsGate.tsx and structurally identical: a headless
// (`return null`) component mounted once at app root that reacts to consent.
// When the user has granted the 'location' category, it warm-loads the Locance
// in-page scripts so the first money-moment geo-check (useLocanceGeoCheck) is
// instant instead of paying script-injection latency at the worst moment.
//
// Privacy-preserving, mirroring AnalyticsGate's "no consent = no pixels": with
// no 'location' consent, NO Locance script is injected. Warm-loading only
// *loads* the scripts (installs window.lshtml5 / window.lsdp) — it does NOT
// call the collector or profiler, so no location prompt and no profiling event
// fires here. The actual gather happens only when a money moment runs the hook.

import { useEffect } from 'react';
import { hasConsent, subscribeConsent } from '@/lib/consent';
import { loadLocanceScripts } from '@/lib/locance';

export default function LocationGate() {
  useEffect(() => {
    const sync = () => {
      if (hasConsent('location')) {
        void loadLocanceScripts().catch(() => {
          // Warm-load failure is non-fatal here: the first real geo-check
          // re-attempts the load and surfaces any error in-flow (denied/error
          // state + toast), which is where the user can act on it.
        });
      }
      // No 'location' consent → inject nothing.
    };

    sync();
    return subscribeConsent(sync);
  }, []);

  return null;
}
